import {Injectable} from "@angular/core";
import {StartupHttpService} from "../http/startup.http.service";
import {SessionStoragePersistenceStore} from "../persistence/session.storage.persistence.store";

@Injectable()
export class ContentServerService {

    private static contentServerTested = false;
    private static contentServerActive = false;
    private static TEST_CONTENT_SERVER_FILE = "/assets/ping.txt";
    private static store: SessionStoragePersistenceStore;
    private static prodContentPathname = "/rav2";

    constructor() {
    }

    private static getLocationQuery(): string {
        return window.location.search.substring(1);
    }

    private static getLocationProtocol(): string {
        let a = document.createElement("a");
        a.href = document.referrer;

        let protocol = a.protocol;
        if (a.host.indexOf("localhost") < 0) {
            protocol = "https:";
        }
        return protocol;
    }

    public static getContentPathname(): string {
        return this.getUrlParameter("content_server_dev") ||   this.prodContentPathname;
    }

    public static setSessionStorageStore(store: SessionStoragePersistenceStore) {
        this.store = store;
    }

    public static getUrlParameter(name): string | null {
        let query = this.getLocationQuery();
        let vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split("=");
            if (pair[0] === name) {
                return decodeURIComponent(pair[1]);
            }
        }
        return null;
    }

    public static determineContentServer(): string | null {
        let sessionContentServer = this.store.getKeySynchronously("content_server");
        let contentServer = this.getUrlParameter("content_server");
        if (!!sessionContentServer) {
            return sessionContentServer;
        } else if (!!contentServer) {
            let parsedContentServer = this.parseContentServer(contentServer);
            return parsedContentServer;
        } else {
            return null;
        }
    }

    public static parseContentServer(contentServer: string): string {
        let protocol = this.getLocationProtocol();
        let raContentPath = this.getContentPathname();
        let fullContentServer = protocol + "//" + contentServer + raContentPath;
        this.store.setKeySynchronously("content_server", fullContentServer);
        return fullContentServer;
    }

    public static checkContentServerAvailable(httpService: StartupHttpService, callback: Function): void {
        let contentServer = this.determineContentServer();
        if (!contentServer) {
            this.contentServerActive = false;
            callback();
        } else if (this.contentServerTested) {
            callback();
        } else {
            this.contentServerTested = true;

            fetch(contentServer + this.TEST_CONTENT_SERVER_FILE).then(
                response => {
                    this.contentServerActive = true;
                    callback();
                }
            ).catch( error => {
                this.contentServerActive = false;
                callback();
            });

        }
    }

    public static isContentServerActive(): boolean {
        return this.contentServerActive;
    }

    public static setContentServerActive(active: boolean): void {
        this.contentServerActive = active;
    }

}
